/*
 * Hiza — WhatsApp launcher + panel
 *
 * There is no chat backend. The panel collects a message and hands it to
 * WhatsApp as prefilled text — the same thing the Chaty app was doing. No
 * message is stored or sent from the site, which is worth knowing before
 * anyone assumes replies land somewhere.
 */
(function () {
  'use strict';

  function build(root) {
    if (root.dataset.hizaWaReady === 'true') return;
    root.dataset.hizaWaReady = 'true';

    var toggle = root.querySelector('[data-hiza-wa-toggle]');
    var panel = root.querySelector('.hz-wa__panel');
    var closeBtn = root.querySelector('[data-hiza-wa-close]');
    var form = root.querySelector('[data-hiza-wa-form]');
    var input = root.querySelector('[data-hiza-wa-input]');
    var timeEl = root.querySelector('[data-hiza-wa-time]');
    if (!toggle || !panel || !form || !input) return;

    // Stamp the greeting with the visitor's own clock, so the bubble reads as
    // a real message rather than a static graphic.
    if (timeEl && !timeEl.textContent) {
      try {
        timeEl.textContent = new Date().toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit'
        });
      } catch (e) {
        timeEl.textContent = '';
      }
    }

    // The panel is taken out of the layout with [hidden] once it has faded, so
    // closing has a tail. That tail must never outlive a reopen: a stale timer
    // that fires after the panel is open again hides a panel the shopper just
    // asked for, and leaves aria-expanded saying "true", so the next click
    // closes instead of opens and the button appears dead. One shared handler
    // (not a fresh closure per close) plus a state check is what prevents it.
    var closeTimer = null;

    function finishClose() {
      // a reopen inside the fade window wins
      if (toggle.getAttribute('aria-expanded') === 'true') return;
      panel.hidden = true;
      panel.removeEventListener('transitionend', finishClose);
    }

    function open() {
      clearTimeout(closeTimer);
      panel.removeEventListener('transitionend', finishClose);
      panel.hidden = false;
      // Force a reflow so the transition has a from-state, rather than waiting
      // a frame: requestAnimationFrame is paused in a backgrounded tab, which
      // would leave the panel laid out but stuck at opacity 0.
      void panel.offsetHeight;
      root.classList.add('hz-wa--open');
      toggle.setAttribute('aria-expanded', 'true');
      try {
        input.focus({ preventScroll: true });
        var v = input.value;
        input.setSelectionRange(v.length, v.length);
      } catch (e) {
        /* focus is a nicety, never a failure */
      }
    }

    function close(returnFocus) {
      root.classList.remove('hz-wa--open');
      toggle.setAttribute('aria-expanded', 'false');
      // still hide it if the transition is suppressed by reduced motion
      panel.addEventListener('transitionend', finishClose);
      clearTimeout(closeTimer);
      closeTimer = setTimeout(finishClose, 400);
      if (returnFocus) toggle.focus();
    }

    toggle.addEventListener('click', function () {
      if (toggle.getAttribute('aria-expanded') === 'true') close(true);
      else open();
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        close(true);
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        close(true);
      }
    });

    // Click outside dismisses, but not a click on the launcher itself.
    document.addEventListener('click', function (e) {
      if (toggle.getAttribute('aria-expanded') !== 'true') return;
      if (root.contains(e.target)) return;
      close(false);
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var phone = (root.dataset.phone || '').replace(/[^\d]/g, '');
      if (!phone) return;
      var text = (input.value || '').trim();
      var url;
      if (root.dataset.linkStyle === 'web') {
        url = 'https://web.whatsapp.com/send?phone=' + phone;
        if (text) url += '&text=' + encodeURIComponent(text);
      } else {
        url = 'https://wa.me/' + phone;
        if (text) url += '?text=' + encodeURIComponent(text);
      }
      window.open(url, '_blank', 'noopener');
      close(false);
    });
  }

  function init() {
    document.querySelectorAll('[data-hiza-whatsapp]').forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
